import { render, staticRenderFns } from "./StatusParcel.vue?vue&type=template&id=07606328&"
import script from "./StatusParcel.vue?vue&type=script&lang=js&"
export * from "./StatusParcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports